<fa-icon [icon]="['fas','envelope']" role="button" matTooltip="Email summary" class="text-primary"
	(click)="openModal();">
</fa-icon>
<div class="modal fade" id="{{modalId}}" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<label>
						{{rma_case?.case_id}}
					</label>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if(rma_case && rma_case?.email_summary){
				<div class="email-summary summary-container" [innerHTML]="rma_case?.email_summary">
				</div>
				}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" data-bs-dismiss="modal">
					OK
				</button>
			</div>
		</div>
	</div>
</div>